import { Box, Container } from '@mui/material'
import { useTranslation } from 'react-i18next'
import Header from '../../../../shared/components/Header'
import NotFilter from '../../../../shared/components/NotFilter'
import SubHeader from '../../../../shared/styles/Subheader'
import OffersModal from '../components/modal/OffersModal'
import 'react-dropzone-uploader/dist/styles.css'
import DeleteOfferDialog from '../components/DeleteOfferDialog'
import OffersHeaderFilters from '../components/OffersHeaderFilters'
import OffersNotifications from '../components/OffersNotifications'
import OffersDataGrid from '../components/table/OffersDataGrid'
import { useOfferTable } from '../hooks/useOfferTable'
import { useOffersFilters } from '../hooks/useOffersFilters'

function Offers() {
  const { t } = useTranslation(['global'])

  const {
    offerState: { offers, showForm, loading },
    openDeleteOffer,
    offerSelected,
    setOpenDeleteOffer,
    handleEdditOffers,
    handleDeleteOffers,
    handleClickHighlight
  } = useOfferTable()
  const { globalBrandId, optionsData, handleClickSetOptions } = useOffersFilters()

  return (
    <>
      {showForm && <OffersModal />}
      <Header title={t('offers')} />
      <SubHeader />

      <Container maxWidth="lg">
        <Box style={{ display: showForm ? 'none' : 'block' }}>
          <OffersHeaderFilters optionsData={optionsData} handleClickSetOptions={handleClickSetOptions} />

          {offers.length === 0 && !loading ? (
            <NotFilter subsection={null} handleClearFilters={handleClickSetOptions} />
          ) : (
            <Box mt={3}>
              <div className="table_custom">
                <OffersDataGrid
                  offers={offers}
                  onDelete={handleDeleteOffers}
                  onEdit={handleEdditOffers}
                  handleClickHighlight={handleClickHighlight}
                  loading={loading}
                  globalBrandId={globalBrandId}
                />
              </div>
            </Box>
          )}
        </Box>

        <DeleteOfferDialog open={openDeleteOffer} offerId={offerSelected} onClose={() => setOpenDeleteOffer(false)} />

        <OffersNotifications />
      </Container>
    </>
  )
}

export default Offers
